/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type GetBackAttivitaV2IdComunicazioniIdTipoDestinatario =
  (typeof GetBackAttivitaV2IdComunicazioniIdTipoDestinatario)[keyof typeof GetBackAttivitaV2IdComunicazioniIdTipoDestinatario];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBackAttivitaV2IdComunicazioniIdTipoDestinatario = {
  RICHIEDENTE: 'RICHIEDENTE',
  TITOLARE: 'TITOLARE',
  RESPONSABILE_PROCEDIMENTO: 'RESPONSABILE_PROCEDIMENTO',
  ENDOPROCEDIMENTI_PRIMO_LIVELLO: 'ENDOPROCEDIMENTI_PRIMO_LIVELLO',
  PROCURATORE: 'PROCURATORE',
  DELEGATI_FIRMA: 'DELEGATI_FIRMA',
  DELEGATI_COMPILAZIONE: 'DELEGATI_COMPILAZIONE',
  ALTRO_UFFICIO_VARIABILE: 'ALTRO_UFFICIO_VARIABILE',
  IMPRESA_TITOLARE: 'IMPRESA_TITOLARE',
  SOGGETTO_GIURIDICO: 'SOGGETTO_GIURIDICO',
  UFFICIO_RICHIEDENTE: 'UFFICIO_RICHIEDENTE',
  UFFICIO_COMPETENZA_SECONDARIA: 'UFFICIO_COMPETENZA_SECONDARIA',
} as const;
